import React from "react";
import { Provider } from "react-redux";
import BrandCarousel from "~/Brands/ExpandedFeatureGroupCarousel/BrandCarousel";
import Item from "~/Brands/ExpandedFeatureGroupCarousel/Item";
import Icon from "~/common/Icons/Standard";
import NotificationCenter from "~/common/Notification/NotificationCenter";
import Store from "~/common/Store";
import { Product } from "~/common/Store/models/ProductListing";
import TopProductsContent from "~/common/TopProductsCarousel/index";
import { ProductListingView } from "~/productListing/ProductBox/AddToCart";
export type TopProductsPageType = "Category" | "Vendor";
interface Props {
  topProducts: Product[];
  productListingView?: ProductListingView;
  itemWidth?: string;
  pageType: TopProductsPageType;
}
const TopProductsCarousel = ({
  topProducts = [],
  productListingView,
  itemWidth,
  pageType
}: Props) => {
  const buttonStyle = "bg-white border-gray-200 border-solid border-0 cursor-pointer hidden h-full mx-0 absolute top-0 z-30 xs:inline-block";
  const iconStyle = "h-5 fill-current text-green-400 w-5";
  const iconWrapperClass = "h-full absolute top-0 w-4";
  return <Provider store={Store} data-sentry-element="Provider" data-sentry-component="TopProductsCarousel" data-sentry-source-file="TopProductsCarousel.tsx">
      <h2 className="mt-3 ml-3 xs:ml-0 header-3">Top Products</h2>
      <NotificationCenter data-sentry-element="NotificationCenter" data-sentry-source-file="TopProductsCarousel.tsx" />
      <div className="bg-white border-gray-200 border-solid border box-border relative w-full xs:rounded" data-testid="Carousel Wrapper" data-feature-name={`${pageType} - Top Products`} data-gtm-component="carousel" gtm-carousel-name="Top Products">
        <BrandCarousel slideRight={({
        onClick
      }) => <button aria-label="Next set of slides" className={`${buttonStyle} rounded-r border-l right-0 outline-offset-[-10px]`} type="button" onClick={onClick} data-testid="right-button">
              <div style={{
          left: "-16px",
          boxShadow: "inset -5px 0 8px -5px rgba(0, 0, 0, 0.25)"
        }} className={iconWrapperClass} />
              <Icon name="right-open" className={iconStyle} />
            </button>} slideLeft={({
        onClick
      }) => <button aria-label="Previous set of slides" className={`${buttonStyle} rounded-l border-r left-0 outline-offset-[-10px]`} type="button" onClick={onClick} data-testid="left-button">
              <div style={{
          right: "-16px",
          boxShadow: "inset 5px 0 8px -5px rgba(0, 0, 0, 0.25)"
        }} className={iconWrapperClass} />
              <Icon name="left-open" className={iconStyle} />
            </button>} listWrapperProps={{
        className: "flex mb-0 ml-0 relative left-px w-[calc(100%-1px)]"
      }} data-sentry-element="BrandCarousel" data-sentry-source-file="TopProductsCarousel.tsx">
          {topProducts.map((product, index) => product && <Item key={product.itemNumber} listItemProps={{
          className: "border-gray-200 border-solid border-0 border-r overflow-hidden p-4 top-1/2"
        }} itemWidth={itemWidth}>
                  <TopProductsContent product={product} mounted index={index} key={product.itemNumber} productListingView={productListingView} />
                </Item>)}
        </BrandCarousel>
      </div>
    </Provider>;
};
export default TopProductsCarousel;